import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { RealTimePriceChange } from 'lib/Presenters/BuyerIntelligencePresenter/types';
import { format } from 'date-fns';
import dot from 'public/static/images/vdp/dot.svg';
import priceChangeGraph from 'public/static/images/vdp/price-change-graph.svg';
import { formatMoney } from 'accounting';
import styles from './styles';

function getPriceAttributes(priceChange: RealTimePriceChange): { deltaColor: string } {
  let deltaColor;
  const priceChangeDelta = priceChange.delta ? priceChange.delta : 0;
  if (priceChangeDelta > 0) {
    deltaColor = 'red';
  } else if (priceChangeDelta < 0) {
    deltaColor = 'green';
  } else {
    deltaColor = 'black';
  }
  return { deltaColor };
}

interface PriceHistoryListProps {
  realTimePriceChanges: RealTimePriceChange[];
  expanded: boolean;
}

function PriceHistoryList({ realTimePriceChanges, expanded }: PriceHistoryListProps): JSX.Element {
  const { t } = useTranslation();

  const priceChangeArray = expanded ? realTimePriceChanges : realTimePriceChanges.slice(0, 5);

  function deltaText(priceChangeDelta: number, i: number): string {
    if (i === realTimePriceChanges.length - 1) {
      return t('vdp.listed');
    }

    return formatMoney(priceChangeDelta, {
      precision: 0,
      format: {
        pos: '+%s%v',
        neg: '-%s%v',
        zero: '%s%v',
      },
    });
  }
  return (
    <div className="price-history-container inherit">
      {realTimePriceChanges.length > 0 ? (
        <ol className="price-history-list">
          {priceChangeArray.map((priceChange, i) => {
            const { deltaColor } = getPriceAttributes(priceChange);
            const priceChangeDelta = priceChange.delta ? priceChange.delta : 0;
            const formattedDate = format(priceChange.date, 'MM/dd/y');
            const historyClass = i !== 0 ? 'strike-through' : '';
            return (
              <Fragment key={i}>
                <li className="price-item price-history-date">
                  {i === 0 ? (
                    <img className="dot" src={dot} alt="dot" />
                  ) : (
                    <div className="gray-dot" />
                  )}
                  {formattedDate}
                </li>
                <li className={`price-item price-history-delta ${deltaColor}`}>
                  {deltaText(priceChangeDelta, i)}
                </li>
                <li
                  className={`price-item price-history-price ${historyClass}`}
                >{`$${priceChange.price.toLocaleString()}`}</li>
              </Fragment>
            );
          })}
        </ol>
      ) : (
        <div className="empty-state">
          <img className="graph-icon" src={priceChangeGraph} alt="price-change-icon" />
          <div className="empty-copy">{t('vdp.noPriceChangeHistory')}</div>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
}

export default PriceHistoryList;
